module.exports = __webpack_public_path__ + "static/media/gu.037043f8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gu.svg
// module id = 664
// module chunks = 0